.container {
  background: #FFFFFF14;
  border-width: 1px 0 1px 0;
  border-style: solid;
  border-color: #DEDEDE1F;
  box-shadow: -4px 0 6px 0 #00000005 inset;
  backdrop-filter: blur(64px);
  border-radius: 100px;
  width: 100%;
  display: flex;
}

/* A button, styled like the plate it used to be. */
.item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 12px 4px;
  border: 0;
  background: transparent;
  font: inherit;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

/* The ring tells a keyboard user which tab they are on (SF-J2). It is drawn *outside* the pill,
   on the row's dark glass, in a fixed white: inside the pill a ring would have to change colour
   between the white selected tab and the transparent others, and `currentColor` would only be
   visible by the accident of no page colour being set. */
.item:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}

.active {
  background-color: white;
}
